export const createHistoryEntry = (
  defaultName = "",
  defaultDate = new Date(),
  defaultNote = ""
) => {
  return {
    id: null, //id is only set after it is saved to the DB
    name: defaultName,
    date: defaultDate,
    note: defaultNote,
  };
};

export const createAssessmentTemplateData = (
  defaultOmniVersion = "1",
  defaultCreatedBy = "",
  defaultCreatedDate = "",
  defaultModifiedBy = "",
  defaultModifiedDate = "",
  defaultIsActive = false,
  defaultOmniSchema = "assessmentTemplate",
  defaultOmniSchemaVersion = "1",
  defaultOmniType = "",
  defaultOmniTypeVersion = 1,
  defaultTitle = "",
  defaultAbout = "",
  defaultDuration = "",
  defaultDirections = "",
  defaultAttribution = "",
  defaultQuestions = []
) => {
  return {
    _id: null, //id is only set after it is saved to the DB
    omniVersion: defaultOmniVersion,
    createdBy: defaultCreatedBy,
    createdDate: defaultCreatedDate,
    modifiedBy: defaultModifiedBy,
    modifiedDate: defaultModifiedDate,
    isActive: defaultIsActive,
    omniSchema: defaultOmniSchema,
    omniSchemaVersion: defaultOmniSchemaVersion,
    omniType: defaultOmniType,
    omniTypeVersion: defaultOmniTypeVersion,
    omniData: {
      title: defaultTitle,
      about: defaultAbout,
      duration: defaultDuration,
      directions: defaultDirections,
      attribution: defaultAttribution,
      questions: defaultQuestions,
    },
  };
};

export const createQuestionData = (
  defaultNumberText = "",
  defaultText = "",
  defaultSubText = "",
  defaultHelpText = "",
  defaultInstructions = "",
  defaultAnswerValue = "",
  defaultAnswerDate = "",
  defaultAnswerOptions = []
) => {
  return {
    omniID: null, //id is only set after it is saved to the DB
    numberText: defaultNumberText,
    text: defaultText,
    subText: defaultSubText,
    helpText: defaultHelpText,
    instructions: defaultInstructions,
    answerValue: defaultAnswerValue,
    answerDate: defaultAnswerDate,
    answerOptions: defaultAnswerOptions,
  };
};

export const createAnswerOptionData = (
  defaultValue = "",
  defaultDisplayType = "",
  defaultText = "",
  defaultSubText = "",
  defaultHelpText = "",
  defaultNextQuestionID = "",
  defaultIsLast = false
) => {
  return {
    value: defaultValue,
    displayType: defaultDisplayType,
    text: defaultText,
    subText: defaultSubText,
    helpText: defaultHelpText,
    nextQuestionID: defaultNextQuestionID,
    isLast: defaultIsLast,
  };
};
